import { SfmResource } from 'src/AppScopes/resource'
import type { SfmResourceProps } from 'src/AppScopes/resource'

import { Create } from './Create'
import { Edit } from './Edit'
import { List } from './List'
import { Show } from './Show'

export function Resource(props: SfmResourceProps) {
  return (
    <SfmResource
      {...props}
      list={List}
      edit={Edit}
      create={Create}
      show={Show}
    />
  )
}
